import classNames from 'classnames'

import Grid from '../../../common/Grid/Grid'
import type {MatrixRow} from '../MatrixBuild.utils'
import {MatrixColumnType} from '../MatrixBuild.utils'

import MatrixGridRow from './MatrixGridRow/MatrixGridRow'

import styles from './MatrixGrid.css'

type MatrixGridProps = {
  className?: string
  matrix: MatrixRow[]
}

function MatrixGrid({className, matrix}: MatrixGridProps) {
  const countParameterValueColumns = matrix[0]?.columns?.filter(
    ({type}) => type === MatrixColumnType.PARAMETER_NAME,
  )?.length
  const countBuildColumns =
    matrix[0]?.columns?.filter(({type}) => type === MatrixColumnType.PARAMETER_VALUE)?.length ?? 1
  const gridTemplateColumns = `repeat(${countParameterValueColumns}, minmax(auto, max-content)) repeat(${countBuildColumns}, minmax(0, 1fr))`

  return (
    <Grid
      gridId="matrixBuild"
      className={classNames(className, styles.grid)}
      style={{gridTemplateColumns}}
    >
      {matrix.map((row, index, array) => (
        <MatrixGridRow
          key={row.id}
          columns={row.columns}
          isHeader={index === 0}
          withUnderline={
            index !== 0 &&
            index !== array.length - 1 &&
            row.columns[0]?.value !== array[index + 1]?.columns?.[0]?.value
          }
        />
      ))}
    </Grid>
  )
}

export default MatrixGrid
